<template>
  <div>
    <v-expansion-panels v-model="expandedArray">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row>
            <v-col>
              <strong>{{ $t("components.advance.panelTitle") }}: </strong>
              <span
                ><b class="green--text">{{ typeof modelAdvances !== "undefined" ? modelAdvances.length : "" }}</b></span
              >
            </v-col>
            <v-spacer />
            <v-chip class="mr-7" small v-if="countAdvanceErrors !== 0" color="error" text-color="white"
              ><v-icon>warning</v-icon>{{ countAdvanceErrors }}</v-chip
            >
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text>
              <simple-advance-list
                v-on:removeAdvanceItem="removeAdvance"
                :clearable="clearable"
                :validation-model="validationModel"
                :model-advances.sync="contextAdvances"
                :max-date="maxDate"
                :readonly="readonly"
              />
              <v-btn v-if="isAddButtonVisible" color="accent" @click="addAdvance()">{{ $t("global.add") }}</v-btn>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import SimpleAdvanceList from "./SimpleAdvanceList.vue";

export default {
  name: "CollapseSimpleAdvancePanel",
  components: { SimpleAdvanceList },
  data: () => ({
    expandedArray: false
  }),
  props: {
    readonly: {
      required: false,
      default: false
    },
    modelAdvances: {
      required: true
    },
    clearable: {
      required: false,
      default: false
    },
    addable: {
      required: false,
      default: function() {
        return this.$store.getters["userProperties"].system_settings.is_allowed_multiple_delegation_advance === 2;
      }
    },
    validationModel: {
      required: false,
      default: null
    },
    maxDate: {
      required: false,
      default: null
    }
  },
  watch: {
    expanded: function(value) {
      if (value !== false) {
        if (this.modelAdvances.length === 0) {
          // add new advance on panel expand
          this.addAdvance();
        }
      } else {
        // clean empty advances
        for (let index = this.modelAdvances.length - 1; index >= 0; index--) {
          let advance = this.modelAdvances[index];
          if (
            advance.id === null &&
            (advance.amount_in_currency == null || advance.amount_in_currency.length < 1) &&
            advance.payment_type == null &&
            advance.payment_date == null
          ) {
            this.removeAdvance(advance);
          }
        }
      }
    }
  },
  methods: {
    countErrors(item) {
      let count = 0;
      for (let property in item) {
        if (typeof item[property] === "string") {
          return 1;
        }
        if (item[property] !== null && typeof item[property] === "object") {
          count += this.countErrors(item[property]);
        }
      }
      return count;
    },
    removeAdvance(item) {
      this.$emit("removeAdvanceItem", item);
    },
    addAdvance(item) {
      this.$emit("addAdvanceItem", item);
    }
  },
  computed: {
    isAddButtonVisible() {
      return (
        this.addable &&
        !this.readonly &&
        (this.modelAdvances.length < 1 || this.$store.getters["userProperties"].system_settings.is_allowed_multiple_delegation_advance === 2)
      );
    },
    countAdvanceErrors() {
      return this.countErrors(this.validationModel);
    },
    contextAdvances: {
      set(value) {
        this.$emit("update:modelAdvances", value);
      },
      get() {
        return this.modelAdvances;
      }
    },
    expanded() {
      return typeof this.expandedArray !== "undefined" ? this.expandedArray : false;
    }
  }
};
</script>

<style scoped></style>
